module.exports = __webpack_public_path__ + "img/pr-9.fa52dd1b.png";